var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900391 2.25001C0.900391 1.75295 1.30333 1.35001 1.80039 1.35001H4.95039C5.44745 1.35001 5.85039 1.75295 5.85039 2.25001V4.05001C5.85039 4.54706 5.44745 4.95001 4.95039 4.95001H4.05039L2.70039 6.30001V4.95001H1.80039C1.30333 4.95001 0.900391 4.54706 0.900391 4.05001V2.25001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75039 3.15001V3.5228C6.75039 4.80808 5.70846 5.85001 4.42318 5.85001L3.62817 6.64502C3.75408 6.71203 3.8978 6.75001 4.05039 6.75001H4.95039L6.30039 8.10001V6.75001H7.20039C7.69745 6.75001 8.10039 6.34706 8.10039 5.85001V4.05001C8.10039 3.55295 7.69745 3.15001 7.20039 3.15001H6.75039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidChat);
export default __webpack_public_path__ + "static/media/solid-chat.f67dbdb3513a9c076b592da4861a1793.svg";
export { ForwardRef as ReactComponent };